import { Extensions, KeyboardShortcutCommand } from "@tiptap/core";
import { Document } from "@tiptap/extension-document";
import { HardBreak } from "@tiptap/extension-hard-break";
import { Heading, HeadingOptions } from "@tiptap/extension-heading";
import { HorizontalRule } from "@tiptap/extension-horizontal-rule";
import { BulletList, ListItem, OrderedList, ListKeymap } from "@tiptap/extension-list";
import { Paragraph } from "@tiptap/extension-paragraph";
import { Text } from "@tiptap/extension-text";
import { Bold } from "@tiptap/extension-bold";
import { Italic } from "@tiptap/extension-italic";
import { Link } from "@tiptap/extension-link";
import { Strike } from "@tiptap/extension-strike";
import { Underline } from "@tiptap/extension-underline";
import { TextStyle, Color, LineHeight } from "@tiptap/extension-text-style";
import { TextAlign } from "@tiptap/extension-text-align";
import { Dropcursor, Gapcursor, UndoRedo, TrailingNode } from "@tiptap/extensions";
import { WebsiteBuilderRichTextResponsiveFontSize } from "./websiteBuilderRichTextResponsiveFontSize";

export const websiteBuilderParagraphRichTextExtensions: Extensions = [
  BulletList,
  Document.extend({ content: "(paragraph | bulletList | orderedList | horizontalRule)+" }),
  HardBreak,
  HorizontalRule,
  ListItem,
  OrderedList,
  Paragraph,
  Text,
  Bold,
  Italic,
  Link.configure({ openOnClick: false, autolink: false, linkOnPaste: false }),
  Strike,
  Underline,
  TextStyle,
  Color,
  LineHeight.configure({ types: ["paragraph"] }),
  TextAlign.configure({ types: ["paragraph"], alignments: ["left", "center", "right"] }),
  Dropcursor,
  Gapcursor,
  UndoRedo,
  ListKeymap,
  TrailingNode.configure({ node: "paragraph" }),
  WebsiteBuilderRichTextResponsiveFontSize,
];

export const websiteBuilderHeadingRichTextExtensions: Extensions = [
  Document.extend({ content: "heading" }),
  HardBreak.extend({
    addKeyboardShortcuts() {
      return {
        ...this.parent?.(),
        Enter: () => this.editor.commands.setHardBreak(),
      };
    },
  }),
  Heading.extend<HeadingOptions>({
    addKeyboardShortcuts() {
      return this.options.levels.reduce<Record<string, KeyboardShortcutCommand>>((shortcuts, level) => ({
        ...shortcuts,
        [`Mod-Alt-${level}`]: () => this.editor.commands.updateAttributes(this.name, { level }),
      }), {});
    },
  }),
  Text,
  Italic,
  Strike,
  Underline,
  TextStyle,
  Color,
  LineHeight.configure({ types: ["heading"] }),
  TextAlign.configure({ types: ["heading"], alignments: ["left", "center", "right"] }),
  Dropcursor,
  UndoRedo,
  WebsiteBuilderRichTextResponsiveFontSize,
];
